import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import {Container} from '@mui/material';

export default function LoadingProgressComponent(props: any) {
    const {children, isLoading} = props;
    return isLoading ? <Container sx={{position: 'absolute', width: '90px', top: '40%', left: '50%'}}><CircularProgress/></Container> : children;
}